"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const TreeView_1 = __importDefault(require("@mui/lab/TreeView"));
const TreeItem_1 = __importStar(require("@mui/lab/TreeItem"));
const material_1 = require("@mui/material");
const styles_1 = require("@mui/material/styles");
const iconoir_react_1 = require("iconoir-react");
const html_react_parser_1 = __importDefault(require("html-react-parser"));
// import app components
const colors_1 = __importDefault(require("../../../theme/colors"));
const typography_1 = __importDefault(require("../../elements/typography"));
const searchTree_1 = __importDefault(require("../../../utils/searchTree"));
const StyledTreeItem = (0, styles_1.styled)((props) => react_1.default.createElement(TreeItem_1.default, { ...props }))(({ theme }) => ({
    [`& .${TreeItem_1.treeItemClasses.iconContainer}`]: {
        "& .close": {
            opacity: 0.3,
        },
    },
    [`& .${TreeItem_1.treeItemClasses.group}`]: {
        marginLeft: 14,
        paddingLeft: 6,
        borderLeft: `2px dotted ${(0, styles_1.alpha)(theme.palette.text.primary, 0.4)}`,
    },
}));
const getExpandedAndSelectedStatus = (tree, slug) => {
    if (!tree) {
        return { expanded: [], selected: [] };
    }
    const items = (0, searchTree_1.default)([tree], slug);
    const expanded = items.map((o) => o.id);
    const selected = expanded.length > 0 ? [expanded.slice(-1)[0]] : [];
    return { expanded, selected };
};
const MenuTree = (props) => {
    const { linkComponent, tree, slug, ...rest } = props;
    // Remove hashes from slug
    const formattedSlug = slug.split("#")[0];
    const { expanded: defaultExpanded, selected: defaultSelected } = getExpandedAndSelectedStatus(tree, formattedSlug);
    const [expanded, setExpanded] = (0, react_1.useState)(defaultExpanded);
    const [selected, setSelected] = (0, react_1.useState)(defaultSelected);
    /**
     * Update expanded and selected items on initial load and whenever slug changes (e.g. user clicks link in content area)
     */
    (0, react_1.useEffect)(() => {
        const { expanded, selected } = getExpandedAndSelectedStatus(tree, formattedSlug);
        setExpanded(expanded);
        setSelected(selected);
    }, [tree, formattedSlug]);
    const renderTree = (node) => {
        const active = node.slug === formattedSlug;
        return (react_1.default.createElement(StyledTreeItem, { key: node.id, nodeId: node.id, collapseIcon: react_1.default.createElement(iconoir_react_1.NavArrowDown, { style: { color: colors_1.default.icons[700], fontSize: "0.7rem" } }), expandIcon: react_1.default.createElement(iconoir_react_1.NavArrowRight, { style: { color: colors_1.default.icons[700], fontSize: "0.7rem" } }), endIcon: node.icon, sx: {
                "> .MuiTreeItem-content > .MuiTreeItem-label > .MuiTypography-root": {
                    paddingRight: "10px",
                    display: "flex",
                },
                a: {
                    display: "flex",
                    textDecoration: "none",
                    transition: "ease all 0.2s !important",
                    color: colors_1.default.text[100],
                    "&:hover": {
                        color: `${colors_1.default.primary[900]} !important`,
                    },
                },
            }, label: react_1.default.createElement(react_1.default.Fragment, null, node.slug ? (react_1.default.createElement(react_1.default.Fragment, null, active ? (react_1.default.createElement(typography_1.default, { variant: "body2", sx: { color: colors_1.default.primary[900] } }, (0, html_react_parser_1.default)(node.title))) : (react_1.default.createElement(material_1.Link, { variant: "body2", component: linkComponent, href: node.slug, sx: { color: colors_1.default.text[100] } }, (0, html_react_parser_1.default)(node.title))))) : (react_1.default.createElement(react_1.default.Fragment, null, Array.isArray(node.children) && node.children.length > 0 ? (react_1.default.createElement(typography_1.default, { variant: "body2", sx: { color: colors_1.default.text[100] } }, (0, html_react_parser_1.default)(node.title))) : node.onClick ? (react_1.default.createElement(material_1.Box, { sx: {
                    color: colors_1.default.text[100],
                    "&:hover": {
                        color: colors_1.default.primary[900],
                    },
                }, onClick: node.onClick },
                react_1.default.createElement(typography_1.default, { variant: "body2", color: "inherit" }, (0, html_react_parser_1.default)(node.title)))) : (react_1.default.createElement(typography_1.default, { variant: "subtitle2", sx: { mt: 2, color: colors_1.default.text[700] } }, (0, html_react_parser_1.default)(node.title)))))), ...rest }, Array.isArray(node.children) && node.children.map((childNode) => renderTree(childNode))));
    };
    const handleToggle = (e, nodeIds) => {
        setExpanded(nodeIds);
    };
    const handleSelect = (e, nodeIds) => {
        setSelected(nodeIds);
    };
    return (react_1.default.createElement(TreeView_1.default, { expanded: expanded, selected: selected, onNodeToggle: handleToggle, onNodeSelect: handleSelect, sx: {
            ".MuiTreeItem-root": {
                padding: "5px 0",
            },
            ".MuiTreeItem-content": {
                alignItems: "center",
                "&.Mui-focused, &:hover, &.Mui-selected": {
                    backgroundColor: "transparent !important",
                },
                ".MuiTreeItem-iconContainer": {
                    marginTop: "1px",
                },
            },
        } }, renderTree(tree)));
};
exports.default = MenuTree;
